<template>
    <section class="main df">
        <div class="l-box">
            <!--<img src="https://img.vhiphop.top/admin/video/2018/8/28/1535398862445.jpg" alt="">-->
            <div v-show="!top.id && id === uid" class="item top df ac">
                <div @click="showTop" class="add-box df cp">
                    <i class="icon-add"></i>
                    设置置顶视频
                </div>
                选择你最喜欢的作品，让大家一起欣赏
            </div>
            <div v-if="top.id" class="item top df">
                <a :href="`/videos/${top.id}`" class="top-video-box df pr" :style="`background-image: url('${top.thumb}')`" target="_blank">
                    <div class="opus-mask">
                        <i class="icon-play"></i>
                    </div>
                    <div v-if="top.duration" class="time">{{$duration(top.duration)}}</div>
                </a>
                <div class="top-meta-box pr">
                    <a class="top-video-title" :href="`/videos/${top.id}`" target="_blank">{{top.title}}</a>

                    <div class="add-modal-meta-box df">
                        <div class="top-video-meta">
                            <i class="icon-video"></i>{{top.views}}
                        </div>
                        <div class="top-video-meta">
                            <i class="icon-like"></i>{{top.likes}}
                        </div>
                        <div class="top-video-meta">
                            <i class="icon-clock"></i>{{$time(top.addtime)}}
                        </div>
                    </div>
                    <div v-show="top.reason" class="top-reason dc">
                        推荐理由：{{top.reason}}
                    </div>
                    <div v-if="id === uid" class="top-btn-box pa df">
                        <div @click="showTop" class="add-modal-btn sure bg">编辑置顶</div>
                        <div @click="cancelTop" class="add-modal-btn unfollow">取消置顶</div>
                    </div>
                </div>
            </div>
            <transition name="modal-box">
                <div v-show="topShow" class="top-add-modal">
                    <transition name="modal">
                        <div v-show="topShow" class="add-modal-main">
                            <div class="add-modal-header df">
                                请选择置顶视频
                                <i @click="closeTop" class="icon-close df cp"></i>
                            </div>
                            <div class="add-modal-body">
                                <div class="pr">
                                    <input v-model="topKeyword" @keyup.enter="search" type="text" class="add-modal-search" placeholder="搜索我上传的视频">
                                    <input type="text" name="hidden" class="input-hidden">
                                    <i @click="search" class="icon-search df cp"></i>
                                </div>
                                <div class="add-modal-title">
                                    视频列表
                                </div>
                                <div v-show="topLoading" class="add-modal-wrap df jcc ac">
                                    <div class="loading-big"></div>
                                </div>
                                <div class="add-modal-wrap empty" v-show="!topLoading && !topTotal">
                                    <i class="icon-empty"></i>
                                    <div v-show="!searchedKeyword">你还没有投过视频哦</div>
                                    <div v-show="searchedKeyword">没有找到关于“ <span class="dc">{{searchedKeyword}}</span> ”的视频哦</div>
                                </div>
                                <div v-show="!topLoading && topTotal" class="add-modal-wrap">
                                    <div class="add-modal-video">
                                        <div v-for="v in topVideos" :key="v.id" @click="topSelected = v" :class="`add-modal-list${topSelected.id === v.id ? ' selected' : ''}`">
                                            <img :src="v.thumb" class="add-modal-cover" alt="">
                                            <div class="ellipsis">
                                                {{v.title}}
                                                <div class="add-modal-meta-box df">
                                                    <div class="add-modal-meta">
                                                        <i class="icon-video"></i>{{$view(v.views)}}
                                                    </div>
                                                    <div class="add-modal-meta">
                                                        <i class="icon-clock"></i>{{$time(v.addtime)}}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <el-pagination
                                            v-if="topTotal > 5"
                                            background
                                            layout="total, prev, pager, next"
                                            @current-change="nextPage"
                                            :page-size="5"
                                            :current-page="topPage"
                                            :total="topTotal"
                                            class="top-page">
                                    </el-pagination>
                                    <div :class="`reason-box pr ${(topReason || topSelected.id) ? 'vv' : 'vh'}`">
                                        <input v-model="topReason" type="text" class="add-modal-reason" maxlength="40" placeholder="请输入置顶理由">
                                        <input type="text" name="hidden" class="input-hidden">
                                        <div class="reason-counter pa df">{{topReason.length}}/40</div>
                                    </div>

                                    <div class="add-btn-box df">
                                        <div @click="saveTop" class="add-modal-btn sure bg">确定</div>
                                        <div @click="closeTop" class="add-modal-btn unfollow">取消</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </transition>
                </div>
            </transition>

            <div class="item">
                <div class="item-title">
                    <router-link :to="`${id}/collect`" class="item-link">{{owner}}的收藏夹</router-link>
                    <router-link v-if="collect.video.total || collect.activity.total || collect.info.total" :to="`${id}/collect`" class="more">更多 &gt;</router-link>
                </div>
                <div class="df">
                    <div v-if="collect.video.total" class="collect-box">
                        <router-link :to="`${id}/collect`" class="collect-link" :style="`background-image: url('${collect.video.thumb}')`">
                            <span class="collect-count">{{collect.video.total}}</span>
                        </router-link>
                        <router-link :to="`${id}/collect`" class="collect-title-link">视频收藏夹</router-link>
                    </div>
                    <div v-if="collect.activity.total" class="collect-box">
                        <router-link :to="`${id}/collect/activities`" class="collect-link" :style="`background-image: url('${collect.activity.thumb}')`">
                            <span class="collect-count">{{collect.activity.total}}</span>
                        </router-link>
                        <router-link :to="`${id}/collect/activities`" class="collect-title-link">动态收藏夹</router-link>
                    </div>
                    <div v-if="collect.info.total" class="collect-box">
                        <router-link :to="`${id}/collect/info`" class="collect-link"  :style="`background-image: url('${collect.info.thumb}')`">
                            <span class="collect-count">{{collect.info.total}}</span>
                        </router-link>
                        <router-link :to="`${id}/collect/info`" class="collect-title-link">资讯收藏夹</router-link>
                    </div>
                    <div v-if="!collect.video.total && !collect.activity.total && !collect.info.total" class="empty">
                        <i class="icon-empty"></i>
                        空间主人还没有收藏任何内容哦~
                    </div>
                </div>
            </div>

            <div class="item">
                <div class="item-title">
                    <router-link :to="`${id}/opuses`" class="item-link">{{owner}}的作品</router-link>
                    <router-link v-if="opus.length" :to="`${id}/opuses`" class="more">更多 &gt;</router-link>
                </div>
                <div class="item-list df">
                    <div v-for="v in opus" class="opus-box">
                        <a :href="`/videos/${v.id}`" class="opus-link" target="_blank" :style="`background-image: url('${v.thumb}')`">
                            <div class="opus-mask">
                                <i class="icon-play"></i>
                            </div>
                            <div v-if="v.duration" class="time">{{$duration(v.duration)}}</div>
                        </a>

                        <a :href="`/videos/${v.id}`" class="opus-title-link" target="_blank">{{v.title}}</a>

                        <div class="add-modal-meta-box df">
                            <div class="top-video-meta">
                                <i class="icon-video"></i>{{$view(v.views)}}
                            </div>
                            <div class="top-video-meta">
                                <i class="icon-clock"></i>{{$date(v.addtime)}}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!opus.length" class="empty">
                    <i class="icon-empty"></i>
                    空间主人还没有投过视频哦~
                </div>
            </div>

            <div class="item">
                <div class="item-title">
                    <router-link :to="`${id}/opuses`" class="item-link">最近赞过的视频</router-link>
                </div>
                <div class="item-list df">
                    <div v-for="v in likes" class="opus-box">
                        <a :href="`/videos/${v.id}`" class="opus-link" target="_blank" :style="`background-image: url('${v.thumb}')`">
                            <div class="opus-mask">
                                <i class="icon-play"></i>
                            </div>
                            <div v-if="v.duration" class="time">{{$duration(v.duration)}}</div>
                        </a>

                        <a :href="`/videos/${v.id}`" class="opus-title-link" target="_blank">{{v.title}}</a>

                        <div class="add-modal-meta-box df">
                            <div class="top-video-meta">
                                <i class="icon-video"></i>{{$view(v.views)}}
                            </div>
                            <div class="top-video-meta">
                                <i class="icon-clock"></i>{{$date(v.addtime)}}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!likes.length" class="empty">
                    <i class="icon-empty"></i>
                    空间主人最近没有赞过视频哦~
                </div>
            </div>
        </div>
        <div class="r-box">
            <div v-if="id === uid" class="r-item">
                <div class="manage-main df">
                    <a class="manage-link upload-link" href="/users/upload" target="_blank">
                        <i class="icon-upload"></i>
                        视频投稿
                    </a>
                    <a class="manage-link" href="/users/manage" target="_blank">
                        <i class="icon-manage"></i>
                        内容管理
                    </a>
                </div>
            </div>

            <div v-if="notice || id === uid" class="r-item">
                <div class="r-title">公告</div>
                <div v-if="id === uid" class="pr">
                    <textarea v-model="notice" @change="updateNotice" class="area" rows="4" maxlength="150" placeholder="编辑我的空间公告"></textarea>
                    <div class="area-counter">{{notice.length}} / 150</div>
                </div>
                <div class="notice" v-if="id !== uid">{{notice}}</div>
            </div>

            <div class="r-item">
                <div class="r-title">
                    关注的舞者
                    <router-link v-show="dancers.length" :to="`${id}/follow/dancers`" class="more">更多 &gt;</router-link>
                </div>
                <div v-if="dancers.length" class="df">
                    <a v-for="v in dancers" class="dancer-link" :href="`/dancers/${v.id}`" target="_blank">
                        <div class="dancer-cover" :style="`background-image: url('${v.thumb}')`"></div>
                        <p class="dancer-name">{{v.name}}</p>
                    </a>
                </div>
                <div v-show="!dancers.length" class="none">
                    空间主人还没有关注舞者
                </div>
            </div>
            <div class="r-item">
                <div class="r-title">
                    关注的工作室
                    <router-link v-show="studios.length" :to="`${id}/follow/studios`" class="more">更多 &gt;</router-link>
                </div>
                <div v-if="studios.length" class="df">
                    <a v-for="v in studios" class="dancer-link" :href="`/studios/${v.id}`" target="_blank">
                        <div class="dancer-cover" :style="`background-image: url('${v.thumb}')`"></div>
                        <p class="dancer-name">{{v.name}}</p>
                    </a>
                </div>
                <div v-show="!studios.length" class="none">
                    空间主人还没有关注工作室
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            up: Object,
        },
        data: () => ({
            top: {},
            notice: '',
            noticeUpdating: false,
            topShow: false,
            topVideos: [],
            topTotal: 0,
            topLoading: false,
            topPaging: false,
            topPage: 1,
            topSelected: {},
            topReason: '',
            topSaving: false,
            topKeyword: '',
            searchedKeyword: '',
            collect: {
                video: {},
                activity: {},
                info: {}
            },
            opus: [],
            likes: [],
            dancers: [],
            studios: [],
        }),
        watch: {
            'up.notice'(e) {
                this.notice = e;
            }
        },
        computed: {
            id() {
                return +this.$route.params.id;
            },
            user() {
                return this.$store.state.user;
            },
            uid() {
                return this.user.id;
            },
            sign() {
                return this.$store.state.sign;
            },
            tab() {
                return this.$route.name
            },
            owner() {
                return this.id === this.uid ? '我' : 'TA';
            }
        },
        methods: {
            updateNotice() {
                if (this.noticeUpdating) return;
                this.noticeUpdating = true;

                const {notice} = this;
                this.api.patch('users/update', {notice}).then(() => {
                    this.$emit('noticeUpdate', notice);
                    this.noticeUpdating = false;
                    this.alert.suc('公告修改成功');
                }, e => {
                    this.noticeUpdating = false;
                    this.alert.err(e.message);
                });
            },
            async showTop() {
                if (this.topLoading) return;
                this.topLoading = true;
                this.searchedKeyword = this.topKeyword = '';
                this.topReason = this.top.reason || '';
                this.topShow = true;
                this.topSelected = this.top.id ? this.top : {};
                this.topTotal = this.user.opus;
                this.topVideos = await this.api.get('spaces/tops', {page: this.topPage}).catch(this.err);
                this.topLoading = false;
            },
            closeTop() {
                this.topShow = this.topLoading = false;
            },
            saveTop() {
                if (this.topSaving) return;
                this.topSaving = true;
                const {topSelected, topReason} = this;
                topSelected.reason = topReason;
                this.api.patch('users/update', {top: topSelected.id, top_reason: topReason}).then(() => {
                    this.closeTop();
                    this.top = topSelected;
                    this.topSaving = false;
                }, e => {
                    this.alert.err(e.message);
                    this.topSaving = false;
                });
            },
            cancelTop() {
                if (this.topSaving) return;
                this.confirm({
                    title: '确认提示',
                    content: '确认要取消置顶视频吗？',
                    sure: '确定',
                    cancel: '取消',
                    sureCb: () => {
                        this.topSaving = true;
                        this.api.patch('users/update', {top: 0, top_reason: ''}).then(() => {
                            this.top = {};
                            this.topSaving = false;
                        }, e => {
                            this.alert.err(e.message);
                            this.topSaving = false;
                        });
                    },
                });
            },
            async nextPage(page) {
                if (this.topPaging) return;
                this.topPaging = true;
                this.topPage = page;
                this.topVideos = await this.api.get('spaces/tops', {keyword: this.searchedKeyword, page}).catch(this.err);
                this.topPaging = false;
            },
            async search() {
                if (this.topLoading) return;
                this.topLoading = true;
                this.topPage = 1;
                const params = {keyword: this.topKeyword}, {api} = this;
                api.get('spaces/tops/count', params).then(e => this.topTotal = e, this.err);
                this.topVideos = await api.get('spaces/tops', params).catch(this.err);
                this.searchedKeyword = this.topKeyword;
                this.topLoading = false;
            }
        },
        beforeMount() {
            const {api, id} = this, host = `users/${id}/spaces/`;
            this.notice = this.up.notice;
            Promise.all([
                api.get(`${host}tops`).then(e => {
                    if (e) this.top = this.topSelected = e;
                }),
                api.get(`${host}collect/count`).then(e => this.collect = e),
                api.get(`${host}opuses`).then(e => this.opus = e),
                api.get(`${host}likes`).then(e => this.likes = e),
                api.get(`${host}dancers`).then(e => this.dancers = e),
                api.get(`${host}studios`).then(e => this.studios = e),
            ]).catch(e => this.alert.err(e.message));
        }
    }
</script>

<style scoped>
    @import "../../../static/css/views/space/home.css";
</style>


// WEBPACK FOOTER //
// src/views/space/Home.vue